
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_101_2310)"}},[_c('path',{attrs:{"d":"M11.333 2a1.884 1.884 0 013.22 1.333A1.887 1.887 0 0114 4.667l-9 9-3.667 1 1-3.667 9-9z","stroke":"#667080","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","opacity":".5"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_101_2310"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    